<!-- 抽奖页面2 -->
<template>
  <div class="out-container">
    <div
      class="award-open-container animate__animated animate__fadeIn"
      :style="{ backgroundImage: 'url(' + bgc[1] + ')' }"
    >
      <div class="eggs-container">
        <div class="eggs-wrap">
          <img
            @click="eggClick(1)"
            class="egg small-egg1"
            :src="
              showOkEgg1
                ? require('../../assets/img/xiangyun/egg.png')
                : require('../../assets/img/xiangyun/broken_egg.png')
            "
            :class="[
              !showOkEgg1 ? 'broken_egg' : '',
              !isOpen1 ? '' : 'animate__animated animate__wobble',
              !isOpen ? 'animate__animated animate__pulse animate__infinite' : '',
            ]"
          />
          <img
            class="chassis small-chassis1"
            :src="require('../../assets/img/xiangyun/chassis.png')"
          />
          <img
            v-if="popupIcon[0].awardIcon"
            class="text text1"
            :src="popupIcon[0].awardIcon"
          />
        </div>

        <div class="eggs-wrap">
          <img
            @click="eggClick(2)"
            class="big-egg"
            :src="
              showOkEgg2
                ? require('../../assets/img/xiangyun/egg.png')
                : require('../../assets/img/xiangyun/broken_egg.png')
            "
            :class="[
              !showOkEgg2 ? 'big-broken_egg' : '',
              !isOpen2 ? '' : 'animate__animated animate__wobble',
              !isOpen ? 'animate__animated animate__pulse animate__infinite' : '',
            ]"
          />
          <img
            class="big-chassis"
            :src="require('../../assets/img/xiangyun/chassis.png')"
          />
          <img
            v-if="popupIcon[1].awardIcon"
            class="big-text"
            :src="popupIcon[1].awardIcon"
          />
        </div>

        <div class="eggs-wrap">
          <img
            @click="eggClick(3)"
            class="egg"
            :src="
              showOkEgg3
                ? require('../../assets/img/xiangyun/egg.png')
                : require('../../assets/img/xiangyun/broken_egg.png')
            "
            :class="[
              !showOkEgg3 ? 'broken_egg' : '',
              !isOpen3 ? '' : 'animate__animated animate__wobble',
              !isOpen ? 'animate__animated animate__pulse animate__infinite' : '',
            ]"
          />
          <img
            class="chassis"
            style="z-index: 777"
            :src="require('../../assets/img/xiangyun/chassis.png')"
          />
          <img v-if="popupIcon[2].awardIcon" class="text" :src="popupIcon[2].awardIcon" />
        </div>
      </div>

      <div class="silk-wrap">
        <img class="silk" :src="require('../../assets/img/xiangyun/silk.png')" />
      </div>

      <div class="hammer-wrap">
        <img class="hammer" :src="require('../../assets/img/xiangyun/hammer.png')" />
      </div>

      <div class="right-float-wrapper" @click="toAwardLog">
        <div class="float-box">
          <span>我的奖品</span>
        </div>
      </div>

      <!-- <van-popup position="center" class="popup-content" v-model="showPopup">
        <img
          :src="awardPrice === 6.6 ? popupIcon[0].url : popupIcon[1].url"
          alt=""
        />
        <div class="block" @click="takeAward"></div>
      </van-popup> -->
      <div v-if="awardList.length > 0" style="height: 100%">
        <div v-for="(item, index) in awardList" :key="index" style="height: 100%"> 
          <div class="" v-if="(item.award_type == 6 || item.award_type == 5 || item.award_type == 2 || item.award_type == 3) && item.popup_image">
            <van-popup position="center" class="award-popup-product" v-model="showPopup">
              <div class="award-popup-product"> 
                <div><div class="close" style="float: right;" @click="showPopup=false">X</div></div>
                <div class="award-img">
                  <img :src="item.popup_image" alt="奖品图片"></img>
                </div>
                <button class="button" v-if="(item.award_type == 6 || item.award_type == 5)" @click="toAwardLogDetails">即刻前往附近兑换点</button>
                <button class="button" v-if="item.award_type == 2" @click="takeAward">领取奖励</button>
              </div>
            </van-popup>
          </div>
          <div style="height: 100%" v-else>
            <van-popup position="center" class="award-popup-wrapper" v-model="showPopup">
              <div class="title-wrapper">
                <p class="title">感谢您品鉴国花瓷西凤酒</p>
                <!-- <p class="title">恭喜您</p>
                <p class="title-desc">感谢您品鉴国花瓷西凤酒产品</p>
                <p class="title-desc">获得以下奖品</p> -->
              </div>
              <div class="award-wrapper">
                <div class="award-item" v-for="(item, index) in awardList" :key="index">
                  <div class="image-wrapper">
                    <img v-if="item.award_type == 5" :src="item.qrcode.product.cover" alt="" />
                    <img v-if="item.award_type == 2" :src="item.award_cover" alt="" />
                  </div>
                  <div class="text-wrapper">
                    <p class="name">{{ item.award_name }}</p>
                    <p v-if="item.award_type == 5" class="desc">请在购买门店进行核销</p>
                    <p v-else-if="item.award_type == 2" class="desc">红包将通过服务号发放</p>
                    <p v-else class="desc">{{ item.award_intro }}</p>
                  </div>
                  <div class="num-wrapper">
                    <p>x1</p>
                  </div>
                </div>
                <!-- <div class="award-item">
                  <div class="image-wrapper">
                    <img src="" alt="" />
                  </div>
                  <div class="text-wrapper">
                    <p class="name">6.6元红包</p>
                    <p class="desc">红包将通过服务号发放</p>
                  </div>
                  <div class="num-wrapper">
                    <p>x1</p>
                  </div>
                </div> -->
              </div>
              <div class="btn-wrapper">
                <button v-if="awardLog && awardLog.award_type == 2" @click="takeAward">
                  领取奖励
                </button>
              </div>
            </van-popup>
          </div>
        </div>
      </div>
      <div v-else style="height: 100%">
        <van-popup position="center" class="award-popup-wrapper" v-model="showPopup">
          <div class="title-wrapper">
            <p class="title">感谢您品鉴国花瓷西凤酒</p>
            <!-- <p class="title">恭喜您</p>
            <p class="title-desc">感谢您品鉴国花瓷西凤酒产品</p>
            <p class="title-desc">获得以下奖品</p> -->
          </div>
          <div class="award-wrapper">
            <div class="award-item" v-for="(item, index) in awardList" :key="index">
              <div class="image-wrapper">
                <img v-if="item.award_type == 5" :src="item.qrcode.product.cover" alt="" />
                <img v-if="item.award_type == 2" :src="item.award_cover" alt="" />
              </div>
              <div class="text-wrapper">
                <p class="name">{{ item.award_name }}</p>
                <p v-if="item.award_type == 5" class="desc">请在购买门店进行核销</p>
                <p v-else-if="item.award_type == 2" class="desc">红包将通过服务号发放</p>
                <p v-else class="desc">{{ item.award_intro }}</p>
              </div>
              <div class="num-wrapper">
                <p>x1</p>
              </div>
            </div>
            <!-- <div class="award-item">
              <div class="image-wrapper">
                <img src="" alt="" />
              </div>
              <div class="text-wrapper">
                <p class="name">6.6元红包</p>
                <p class="desc">红包将通过服务号发放</p>
              </div>
              <div class="num-wrapper">
                <p>x1</p>
              </div>
            </div> -->
          </div>
          <div class="btn-wrapper">
            <button v-if="awardLog && awardLog.award_type == 2" @click="takeAward">
              领取奖励
            </button>
          </div>
        </van-popup>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import Config from '@/config/config'
import { mapGetters } from 'vuex'
import { Toast, NoticeBar, Dialog, Popup } from 'vant'
import FleeReport from '../qrcode/fleeReport'

Vue.use(Dialog).use(Toast).use(NoticeBar).use(Popup)

export default {
  name: 'AwardQingyun',
  data() {
    return {
      awardLog: null,
      awardList: [],
      awardTitle: '抽奖中',
      serial: '',
      checkIndex: -1,
      showMp: false,
      showReport: false,
      needReport: false,
      canDrawAward: true,
      isNotAwarded: false,
      canRequest: true,
      isRolling: false,
      isRoll: false,
      activeIndex: 0,
      isCheck: false,
      showOkEgg1: true, // 鸡蛋图片
      showOkEgg2: true,
      showOkEgg3: true,
      isOpen1: false, // 破蛋效果
      isOpen2: false,
      isOpen3: false,
      isOpen: false, // 是否开过蛋
      showPopup: false, // 领奖弹窗
      awardPrice: 0, // 得奖价钱
      isOneMoreAward: false, // 是否存在再来一瓶奖励
      bgc: [
        // 背景图片
        require('../../assets/img/qingyun-kucun/bg-index.jpg'),
        require('../../assets/img/qingyun-kucun/bg-image.jpg')
      ],
      popupIcon: [
        // 领奖弹窗图片
        {
          price: 6.6,
          isUse: false,
          url: require('../../assets/img/qingyun/hot6.jpg'),
          awardIcon: ''
        },
        {
          price: 66,
          isUse: false,
          url: require('../../assets/img/qingyun/hot66.jpg'),
          awardIcon: ''
        },
        {
          price: 666,
          awardIcon: ''
        }
      ],
      awardIcon: [
        {
          price: 6.6,
          url: require('../../assets/img/xiangyun/text6.png')
        },
        {
          price: 66,
          url: require('../../assets/img/xiangyun/text66.png')
        }
      ],
      noneIcon: [
        {
          price: 6.6,
          url: require('../../assets/img/xiangyun/text-no6.png')
        },
        {
          price: 66,
          url: require('../../assets/img/xiangyun/text-no66.png')
        },
        {
          price: 666,
          url: require('../../assets/img/xiangyun/text-no666.png')
        }
      ]
    }
  },
  components: {
    FleeReport
  },
  computed: {
    ...mapGetters(['userInfo', 'location', 'qrcode', 'subscribe'])
  },
  watch: {
    '$flatSheet.instance.show'(v) {
      if (!v) this.init()
    }
  },
  async created() {
    this.serial = this.$route.query.serial
    console.log(this.serial)
  },
  async mounted() {
    // this.initFleeReport();
    // this.init();
    Toast.loading({ message: '加载中,请稍后' })
    await this.eggClick(1)
  },
  methods: {
    // 金蛋
    init() {
      const bammer_dom = document.querySelector('.bammer')
      bammer_dom.classList.remove('bammer_crush')
      bammer_dom.style.left = '0px'
      this.showOkEgg = true
    },
    async eggClick(index) {
      if (this.isOpen) return
      this.isOpen = true
      switch (index) {
        case 1:
          this.isOpen1 = true
          break
        case 2:
          this.isOpen2 = true
          break
        default:
          this.isOpen3 = true
      }
      setTimeout(() => {
        switch (index) {
          case 1:
            this.showOkEgg1 = false
            break
          case 2:
            this.showOkEgg2 = false
            break
          default:
            this.showOkEgg3 = false
        }
      }, 1000)
      // 开奖，请求抽奖接口
      await this.handleAwardRoll(index)
    },

    handleAwardRoll(index) {
      try {
        const params = {
          serial: this.serial,
          latitude: this.location ? this.location.latitude : '',
          longitude: this.location ? this.location.longitude : '',
          province: this.location ? this.location.province : '',
          city: this.location ? this.location.city : '',
          district: this.location ? this.location.district : '',
          location: this.location ? this.location.address : '',
          province_code: this.location ? this.location.province_code : '',
          city_code: this.location ? this.location.city_code : '',
          district_code: this.location ? this.location.district_code : ''
        }
        // 防止重复点击
        if (!this.canRequest) {
          return
        }
        Toast.loading({ message: '抽奖中,请稍后' })
        var that = this
        this.canRequest = false
        this.axios
          .post('/activity/award/draw/', qs.stringify(params))
          .then((res) => {
            Toast.clear()
            that.canRequest = true
            switch (res.code) {
              case 4000:
                // 设置已抽奖
                this.$store.dispatch('setAwarded')
                // this.awardLog = res.data
                console.log(res.data)
                if (Array.isArray(res.data)) {
                  that.awardList = res.data
                  res.data.forEach((item) => {
                    // 设置存在再来一瓶奖励
                    if (item.award_type === 5) {
                      that.isOneMoreAward = true
                    }
                    // 将默认奖励设置成非再来一瓶奖励
                    if (item.award_type !== 5) {
                      that.awardLog = item
                      console.log(that.awardLog)
                    }
                  })
                } else {
                  that.awardLog = res.data
                  if (res.data.award_type === 5) {
                    that.isOneMoreAward = true
                  }
                  that.awardList = [res.data]
                  that.awardPrice = Number(res.data.award_price)
                  // that._awardIcon(that.awardPrice, index)
                }
                that.showPopup = true
                break
              case 4001:
                Dialog({ message: '该瓶酒已抽过奖' })
                break
              case 4002:
                that._handleNoneIcon()
                Dialog({ message: '谢谢惠顾' })
                break
              case 4037:
                Dialog({ message: res.message })
                break
              default:
                Dialog({ message: '谢谢惠顾' })
            }
          })
          .catch(function(error) {
            Toast.clear()
            that.canRequest = true
            console.log(error)
            that.$router.push({
              name: 'QrcodeError',
              params: { errMsg: '系统错误' }
            })
          })
      } catch (error) {
        Toast.clear()
        this.canRequest = true
        console.log(error)
        Dialog({ message: '抽取失败，请稍后再试' })
      }
    },

    // 中奖图片
    _awardIcon(value, index) {
      // 中奖图片
      const temIndex = this.popupIcon.findIndex((v) => v.price === value)
      this.popupIcon[index - 1].awardIcon = this.awardIcon[temIndex].url

      // 循环推入没有中奖的页面
      this.popupIcon.forEach((v) => {
        this.noneIcon.forEach((e) => {
          if (!v.awardIcon && e.price !== value && !e.isUse) {
            v.awardIcon = e.url
            e.isUse = true
          }
        })
      })
    },

    // 一个都没中
    _handleNoneIcon() {
      this.popupIcon.forEach((v, index) => {
        v.awardIcon = this.noneIcon[index].url
      })
    },

    /**
     * 拨打400电话
     */
    sendCall() {
      window.location.href = 'tel://4000039990'
    },

    /**
     * 判断当前是否窜货
     * 若窜货，弹窗让用户反馈（用户未反馈过）
     */
    initFleeReport() {
      if (this.qrcode && this.qrcode.flee && !this.qrcode.report_count) {
        // 弹窗让用户反馈
        this.needReport = true
      }
    },
    /**
     * 显示举报弹窗
     */
    showReportPopup() {
      Dialog.alert({
        message: '该产品为正品'
      }).then(() => {
        this.showReport = true
      })
    },

    /**
     * 隐藏举报
     */
    hideReportPopup() {
      this.showReport = false
      this.needReport = false
    },

    /**
     * 领取奖品
     * 如果奖品是红包，直接请求接口领取；如果奖品是实物，进到领奖页面
     * TODO 增加领取积分
     */
    takeAward() {
      // 防止重复点击
      if (!this.canRequest) {
        return
      }

      if (this.awardLog.award_type === 0) {
        this.$router.push({
          path: '/user/award/receive',
          query: { logId: this.awardLog.id }
        })
        // 实物奖
      } else if (this.awardLog.award_type === 1) {
        // 领取虚拟奖品
        window.location.href = this.awardLog.award_url
      } else if (this.awardLog.award_type === 2) {
        // 红包
        var that = this
        this.canRequest = false
        var params = {
          id: this.awardLog.id
        }
        this.axios
          .post('/activity/award/receive/', qs.stringify(params))
          .then(function(res) {
            that.canRequest = true
            if (!res.code) {
              var message = '红包已发放，请到微信消息里领取'
              if (that.isOneMoreAward) {
                message = '红包已发放，请到微信消息里领取;再来一瓶奖励请到门店扫码核销'
              }
              Dialog.alert({
                title: '提示',
                message: message
              }).then(() => {
                // 领取后跳转到积分商城
                if (this.userInfo.id) {
                  const storeUrl =
                    Config.creditStoreBaseUrl +
                    '/?name=' +
                    that.userInfo.nickname +
                    '&gender=' +
                    that.userInfo.gender +
                    '&province=' +
                    that.userInfo.province +
                    '&city=' +
                    that.userInfo.city +
                    '&avatar=' +
                    that.userInfo.avatar +
                    '&userCode=' +
                    that.userInfo.openid +
                    '&appId=' +
                    Config.creditStoreAppId +
                    '&phone=' +
                    that.userInfo.mobile
                  window.location.href = storeUrl
                } else {
                  that.$router.push({ path: '/' })
                }
              })
            } else {
              Toast(res.message)
            }
          })
          .catch(function(error) {
            console.log(error)
            that.canRequest = true
            Toast('红包领取失败')
          })
      } else {
        // TODO 增加积分领取
      }
      this.showPopup = false
    },

    /**
     * 跳转到防伪验证页面
     */
    toResult() {
      this.$router.replace({
        path: '/qrcode/result',
        query: { serial: this.serial }
      })
    },
    toReceive() {
      this.$router.push({ path: '/user/award/log' })
    },
    toAwardLog() {
      this.$router.push({ name: 'AwardLog' })
    },
    toAwardLogDetails() {
      this.$router.push({ path: '/user/award/detail', query: { logId: this.awardLog.id }})
    },
    toCreditStore() {
      if (this.userInfo.id) {
        const storeUrl =
          Config.creditStoreBaseUrl +
          '/?name=' +
          this.userInfo.nickname +
          '&gender=' +
          this.userInfo.gender +
          '&province=' +
          this.userInfo.province +
          '&city=' +
          this.userInfo.city +
          '&avatar=' +
          this.userInfo.avatar +
          '&userCode=' +
          this.userInfo.openid +
          '&appId=' +
          Config.creditStoreAppId +
          '&phone=' +
          this.userInfo.mobile
        window.location.href = storeUrl
      } else {
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>

<style>
@import "../../assets/style/lucky-card.css";
</style>

<style lang="scss" scoped>
.out-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding-bottom: 48px;
  overflow: hidden;
}

.award-open-container {
  width: 100%;
  height: 100%;
  // background-image: url("../../assets/img/xiangyun/bg-image.jpg");
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;

  @media screen and (min-height: 710px) {
    #scratch {
      top: 190px;
    }

    .award-wrapper {
      top: 190px;
    }
  }
}

// 领奖弹窗

.popup-content {
  background-color: transparent;
  position: fixed;
  top: 50%;
  left: 50%;
  img {
    width: 300px;
    height: 150px;
  }
  .block {
    position: absolute;
    width: 100px;
    height: 20px;
    bottom: 25px;
    right: 90px;
  }
}
.award-popup-wrapper {
  position: relative;
  width: 320px;
  border-radius: 10px;
  .title-wrapper {
    text-align: center;
    margin: 20px 0;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #000;
      margin: 10px 0;
    }
    .title-desc {
      font-size: 14px;
      color: #aaa;
    }
  }
  .award-wrapper {
    margin: 0px auto;
    width: 280px;
    .award-item {
      position: relative;
      width: 280px;
      height: 60px;
      margin-bottom: 10px;
      .image-wrapper {
        width: 60px;
        height: 60px;
        margin: 0;
        display: inline-block;
        background-color: #aaa;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text-wrapper {
        display: inline-block;
        position: relative;
        width: 160px;
        height: 60px;
        top: -10px;
        .name {
          font-size: 16px;
          color: #000;
          font-weight: bold;
          height: 30px;
          line-height: 30px;
        }
        .desc {
          font-size: 14px;
          color: #aaa;
          height: 25px;
          line-height: 25px;
        }
      }
      .num-wrapper {
        display: inline-block;
        width: 40px;
        height: 60px;
        position: relative;
        top: -20px;
        text-align: right;
        p {
          font-size: 14px;
          color: #aaa;
          height: 60px;
          line-height: 60px;
        }
      }
    }
  }
  .btn-wrapper {
    width: 320px;
    height: 60px;
    margin: 20px 0 1px 0;
    text-align: center;
    button {
      width: 280px;
      height: 40px;
      background-color: #f8c762;
      border: none;
      font-size: 18px;
      color: #fff;
      border-radius: 5px;
    }
  }
}
.award-popup-product{
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: transparent !important;
  .close{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #890b00;
    color: #fff;
    z-index: 222222;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    margin-bottom: 60px;
  }
  .award-img{
    width: 100%;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;  
      transform: scale(1.3); /* 放大 1.2 倍 */  
    }
  }
  .button {
    margin-top: 40px;
    display: inline-block;
    padding: 10px 40px;
    font-size: 16px;
    color: white;
    background: linear-gradient(to bottom, #f40000, #890000);
    border: none;
    border-radius: 15px;
    box-shadow: 3px 3px 15px rgba(0,0,0,0.2);
    cursor: pointer;
    font-weight: bold;
    width: 100%;
  }
  .button:hover {
    background: linear-gradient(to bottom, #f40000, #890000);
  }
}
// 底盘蛋

.eggs-container {
  position: fixed;
  bottom: 94px;
  display: flex;
  display: none;
}

.eggs-wrap {
  width: calc((100vw - 26px) / 3);
  height: calc(100vh / 4);
  position: relative;

  // 两边蛋
  .egg {
    position: absolute;
    width: 66px;
    height: 91px;
    left: 31px;
    top: 11px;
    z-index: 999;
  }

  .chassis {
    position: absolute;
    width: 124px;
    height: 45px;
    top: 95px;
    z-index: 888;
  }

  .small-egg1 {
    left: 45px;
  }

  .small-chassis1 {
    left: 17px;
  }

  .broken_egg {
    width: 72px;
    height: 71px;
    top: 36px;
  }

  .text {
    position: absolute;
    z-index: 1000;
    width: 59px;
    height: 13px;
    top: 55px;
    left: 34px;
  }

  .text1 {
    left: 49px;
  }

  // 中间蛋
  .big-egg {
    position: absolute;
    width: 83px;
    height: 115px;
    left: 30px;
    z-index: 999;
  }
  .big-chassis {
    position: absolute;
    width: 159px;
    height: 58px;
    top: 103px;
    left: -8px;
    z-index: 888;
  }
  .big-broken_egg {
    width: 88px;
    height: 86px;
    top: 35px;
  }

  .big-text {
    position: absolute;
    z-index: 1000;
    width: 73px;
    height: 15px;
    top: 55px;
    left: 34px;
  }
}

// 丝带
.silk-wrap {
  position: fixed;
  bottom: 165px;
  left: 17px;
  width: 357px;
  height: 148px;
  pointer-events: none;
  display: none;
  .silk {
    width: 100%;
    height: 100%;
  }
}

// 锤子
.hammer-wrap {
  position: fixed;
  bottom: 270px;
  right: 84px;
  width: 81px;
  height: 70px;
  display: none;
  .hammer {
    width: 100%;
    height: 100%;
  }
}

.right-float-wrapper {
  position: fixed;
  top: 100px;
  right: 0px;
  width: 50px;
  height: 30px;
  background-color: #fff;
  color: #333;
  z-index: 100;
  border-radius: 30px 0 0 30px;
  .float-box {
    position: relative;
    left: 15px;
    top: 2px;
    width: 35px;
    height: 28px;
    text-align: center;
    span {
      width: 35px;
      font-size: 12px;
      letter-spacing: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/award/qingyun-kucun.vue